// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"b129dce8","321":"b129dce8","364":"f1864e66"}[chunkId] + ".chunk.css";
};